import { WorkloadType } from '@/components/Workload/types';
import { useAuthFun } from '@/hooks/useAuth';
import { GROUPS } from '@/service/apiConf';
import { useEffect, useState } from 'react';

export const useWorkloadAuth = (module: WorkloadType) => {
  const getAuth = useAuthFun(GROUPS.clusterScheduler);
  const [auth, setAuth] = useState<any>({});

  useEffect(() => {
    workloadAuth();
  }, [getAuth]);

  const workloadAuth = async () => {
    const aut = await getAuth('clusters/proxy', '*');
    const obj = {
      LIST_ACCESS: aut,
      CREATE_ACCESS: aut,
      UPDATE_ACCESS: aut,
      DELETE_ACCESS: aut,
      DETAIL_ACCESS: aut,
      PATCH_ACCESS: aut,
    };
    setAuth(obj);
  };

  return auth;
};
